import { z } from "zod";
import { selfCertQSchema } from "@features/account/model/selfCertQ.model";

export const findPasswordPayloadSchema = z.object({
  q: selfCertQSchema,
  account: z.string(),
});

export type FindPasswordPayloadType = z.infer<typeof findPasswordPayloadSchema>;
